module.exports = __webpack_public_path__ + "static/media/green-tickets-logo.eb3c3579.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/green-tickets-logo.png
// module id = 1090
// module chunks = 0